import React, { useState } from 'react';
import { 
  Card, 
  Button, 
  Space, 
  DatePicker, 
  Select, 
  Grid, 
  Row, 
  Col,
  Divider
} from 'antd';
import { 
  ReloadOutlined, 
  FilterOutlined, 
  DownloadOutlined,
  DownOutlined,
  UpOutlined
} from '@ant-design/icons';

const { RangePicker } = DatePicker;
const { Option } = Select;
const { useBreakpoint } = Grid;

const FiltrosHome = ({ 
  filters, 
  handleFilterChange, 
  handleReset, 
  handleSearch, 
  setPagination, 
  pagination,
  opcionesUnidadesProduccion,
  locale,
  onDescargarDatos 
}:any) => {
  const screens = useBreakpoint();
  const [filtrosExpandidos, setFiltrosExpandidos] = useState(false);

  const esMovil = !screens.md;
  const esTablet = screens.md && !screens.lg;

  const handleAplicarFiltros = () => {
    setPagination((prev: any) => ({ ...prev, current: 1 }));
    handleSearch(1, pagination.pageSize);
  };

  const toggleFiltrosExpandidos = () => {
    setFiltrosExpandidos(!filtrosExpandidos);
  };

  // Renderizado para dispositivos grandes
  const renderFiltrosDesktop = () => (
    <Row gutter={[16, 16]} align="middle">
      <Col xs={24} sm={12} md={8} lg={6}>
        <div>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
            Fecha generada:
          </label>
          <RangePicker
            onChange={(dates) => handleFilterChange('fechaGenerada', dates)}
            style={{ width: '100%' }}
            locale={locale}
            size={esMovil ? 'small' : 'middle'}
          />
        </div>
      </Col>

      <Col xs={24} sm={12} md={8} lg={4}>
        <div>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
            Estado pago:
          </label>
          <Select
            value={filters.estadoPago}
            onChange={(value) => handleFilterChange('estadoPago', value)}
            style={{ width: '100%' }}
            size={esMovil ? 'small' : 'middle'}
          >
            <Option value={null}>Todos</Option>
            <Option value="pagada">Pagada</Option>
            <Option value="impaga">Impaga</Option>
          </Select>
        </div>
      </Col>

      <Col xs={24} sm={12} md={8} lg={4}>
        <div>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
            Municipio:
          </label>
          <Select
            value={filters.municipio}
            onChange={(value) => handleFilterChange('municipio', value)}
            style={{ width: '100%' }}
            size={esMovil ? 'small' : 'middle'}
          >
            <Option value={null}>Todas</Option>
            {opcionesUnidadesProduccion?.map((opcion: { Id: number; Nombre: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; }) => (
              <Select.Option key={opcion.Id} value={opcion.Id}>
                {opcion.Nombre}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Col>

      <Col xs={24} sm={12} md={8} lg={5}>
        <div>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
            Tipo infracción:
          </label>
          <Select
            value={filters.tipoInfraccion}
            onChange={(value) => handleFilterChange('tipoInfraccion', value)}
            style={{ width: '100%' }}
            size={esMovil ? 'small' : 'middle'}
          >
            <Option value={null}>Todos</Option>
            <Option value="luces,luces bajas">Luces bajas</Option>
            <Option value="rojo,roja">Cruce semáforo</Option>
            <Option value="velocidad">Exceso de velocidad</Option>
          </Select>
        </div>
      </Col>

      <Col xs={24} sm={12} md={8} lg={5}>
        <div>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
            Tipo infractor:
          </label>
          <Select
            value={filters.tipoInfractor}
            onChange={(value) => handleFilterChange('tipoInfractor', value)}
            style={{ width: '100%' }}
            size={esMovil ? 'small' : 'middle'}
          >
            <Option value={null}>Todos</Option>
            <Option value={0}>Personas</Option>
            <Option value={1}>Empresas</Option>
          </Select>
        </div>
      </Col>
    </Row>
  );

  // Renderizado para dispositivos móviles/tablets con acordeón
  const renderFiltrosMovil = () => (
    <div>
      <Button 
        type="link" 
        onClick={toggleFiltrosExpandidos}
        icon={filtrosExpandidos ? <UpOutlined /> : <DownOutlined />}
        style={{ 
          padding: '0', 
          marginBottom: '16px',
          fontWeight: '500',
          color: '#1890ff'
        }}
      >
        {filtrosExpandidos ? 'Ocultar filtros' : 'Mostrar filtros'}
      </Button>

      {filtrosExpandidos && (
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                Fecha generada:
              </label>
              <RangePicker
                onChange={(dates) => handleFilterChange('fechaGenerada', dates)}
                style={{ width: '100%' }}
                locale={locale}
                size="small"
              />
            </div>
          </Col>

          <Col span={24}>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                Estado pago:
              </label>
              <Select
                value={filters.estadoPago}
                onChange={(value) => handleFilterChange('estadoPago', value)}
                style={{ width: '100%' }}
                size="small"
              >
                <Option value={null}>Todos</Option>
                <Option value="pagada">Pagada</Option>
                <Option value="impaga">Impaga</Option>
              </Select>
            </div>
          </Col>

          <Col span={24}>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                Municipio:
              </label>
              <Select
                value={filters.municipio}
                onChange={(value) => handleFilterChange('municipio', value)}
                style={{ width: '100%' }}
                size="small"
              >
                <Option value={null}>Todas</Option>
                {opcionesUnidadesProduccion?.map((opcion: { Id: number; Nombre: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; }) => (
                  <Select.Option key={opcion.Id} value={opcion.Id}>
                    {opcion.Nombre}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>

          <Col span={24}>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                Tipo infracción:
              </label>
              <Select
                value={filters.tipoInfraccion}
                onChange={(value) => handleFilterChange('tipoInfraccion', value)}
                style={{ width: '100%' }}
                size="small"
              >
                <Option value={null}>Todos</Option>
                <Option value="luces,luces bajas">Luces bajas</Option>
                <Option value="rojo,roja">Cruce semáforo</Option>
                <Option value="velocidad">Exceso de velocidad</Option>
              </Select>
            </div>
          </Col>

          <Col span={24}>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                Tipo infractor:
              </label>
              <Select
                value={filters.tipoInfractor}
                onChange={(value) => handleFilterChange('tipoInfractor', value)}
                style={{ width: '100%' }}
                size="small"
              >
                <Option value={null}>Todos</Option>
                <Option value={0}>Personas</Option>
                <Option value={1}>Empresas</Option>
              </Select>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );

  return (
    <Card
      title="Resumen de infracciones"
      style={{
        marginTop: '2em',
        borderRadius: '8px',
        width: '100%',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}
      extra={
        <Space wrap size={esMovil ? 'small' : 'middle'}>
          <Button 
            icon={<DownloadOutlined />} 
            onClick={onDescargarDatos}
            size={esMovil ? 'small' : 'middle'}
          >
            {esMovil ? 'Descargar' : 'Descargar Datos'}
          </Button>
          <Button 
            icon={<ReloadOutlined />} 
            onClick={handleReset}
            size={esMovil ? 'small' : 'middle'}
          >
            {esMovil ? 'Restablecer' : 'Restablecer'}
          </Button>
        </Space>
      }
    >
      {/* Sección de Filtros */}
      <div style={{
        padding: esMovil ? '16px' : '20px',
        backgroundColor: '#f8f9fa',
        borderRadius: '6px',
        marginBottom: '20px',
        border: '1px solid #e8e8e8'
      }}>
        {esMovil || esTablet ? renderFiltrosMovil() : renderFiltrosDesktop()}

        {/* Botones de acción */}
        <Divider style={{ margin: '16px 0' }} />
        
        <Row justify="space-between" align="middle">
          <Col>
            <Button
              type="primary"
              icon={<FilterOutlined />}
              onClick={handleAplicarFiltros}
              size={esMovil ? 'small' : 'middle'}
              style={{ 
                minWidth: esMovil ? '120px' : 'auto'
              }}
            >
              Aplicar Filtros
            </Button>
          </Col>
          
          {!esMovil && (
            <Col>
              <span style={{ color: '#666', fontSize: '14px' }}>
                {Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length} filtros activos
              </span>
            </Col>
          )}
        </Row>
      </div>
    </Card>
  );
};

export default FiltrosHome;